import { useState } from 'react'
import { FileDownload } from '@/assets/icons'
import { IconButton } from '@/components/icon-button/IconButton'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { trackTimelineEvent } from '@/analytics/utils/timeline-analytics'
import { downloadTimelineAssetExcel } from '../fetch/download-timeline-asset-excel'

interface TimelineAssetDownloadButtonProps {
  assetId: string
}

/**
 * Downloads the living timeline as an Excel file.
 */
export default function TimelineAssetDownloadButton(props: TimelineAssetDownloadButtonProps) {
  const { assetId } = props
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleDownload = async () => {
    if (isLoading) return
    setIsLoading(true)
    setErrorMessage(null)
    trackTimelineEvent(AnalyticsEvent.TimelineAssetDownloadClicked, { timelineAssetId: assetId })
    try {
      await downloadTimelineAssetExcel(assetId, 'Timeline.xlsx')
    } catch (error) {
      console.error('Error downloading timeline Excel:', error)
      setErrorMessage('Download failed. Try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="inline-flex items-center gap-2">
      <IconButton aria-label="Download the Timeline" icon={<FileDownload />} loading={isLoading} onClick={handleDownload} size="xs" variant="outlined" />
      {errorMessage && (
        <span role="alert" className="whitespace-nowrap text-xs font-medium text-red-700">
          {errorMessage}
        </span>
      )}
    </div>
  )
}
